import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.user.pipe(
      take(1),
      tap(user => {
        if (!user) {
          this.router.navigate(['/login']);
        } else if (!user.companyId && !state.url.startsWith('/benutzer-einstellungen')) {
          this.router.navigate(['/benutzer-einstellungen/3']);
        } else if (this.authService.emailVerified === false) {
          this.router.navigate(['/konto-verifizieren']);
        }
      }),
      map(user => !!user)
    );
  }
}
